import { Grid, Typography } from "@mui/material"
import { ISettingsItem, useSettings } from "../../Settings"
import { useTranslation } from "../../i18n"

export default function FooterTitle({ name, variables }: ISettingsItem) {
  const { pageTitle } = useSettings()
  const { t } = useTranslation()
  const { text = [`${t.footer.titleDefault} ${pageTitle}`] } = variables || {}

  return (
    <Grid item className={name ? `${name} footer-title` : "footer-title"}>
      <Typography variant="h6" dangerouslySetInnerHTML={{ __html: text[0] }} />
    </Grid>
  )
}